export const OptionQuarter = () => [
    { label: 'เดือน 1', value: '1' },
    { label: 'เดือน 2', value: '2' },
    { label: 'เดือน 3', value: '3' },
    { label: 'เดือน 4', value: '4' },
];
